





















import { Component, Vue, Prop } from "vue-property-decorator"
import {
  getEnergySumOfSource,
  getSourceProfit,
  getClimateAmt,
  getSum
} from "@/models/inventory"
@Component
export default class InfoBox extends Vue {
  @Prop(Number) public readonly unitcount!: number
  @Prop(String) public readonly sourceName!: string

  get amt() {
    this.$store.state.inventory.inventoryChangeNum
    return getSum(
      this.$store.state.inventory.energySources,
      this.sourceName
    )
  }

  get eSum() {
    this.$store.state.inventory.inventoryChangeNum
    return getEnergySumOfSource(
      this.$store.state.inventory.energySources,
      this.sourceName
    )
    // return this.$store.state.inventory.getEnergySumOfSource(this.sourceName)
  }

  get pSum() {
    this.$store.state.inventory.inventoryChangeNum
    return getSourceProfit(this.$store.state, this.sourceName)
  }

  get cSum() {
    this.$store.state.inventory.inventoryChangeNum
    return getClimateAmt(this.$store.state, this.sourceName)
  }
}
